module.exports = __webpack_public_path__ + "img/whatsapp-in-btn.a723cc2.png";